export default __webpack_public_path__ + "static/media/Levitate D2.6 Policy Support Tool user guide.bfdee155.pdf";